import React, { useEffect, useState } from "react";
import "../../pages/quotation/JobInHand.scss";
import "react-datepicker/dist/react-datepicker.css";
import FetchData from "../../providers/dataProvider";
import CustomerContactSection from "./CustomerContactSection";
import ProjectCommercialTermsSection from "./ProjectCommercialTermsSection";

const AddJobInHand = (params) => {
  const {
    allocatedToData: allocatedToDataProp,
    assignedEngineerList,
    country,
    customer,
    distributor,
    enquirySelection,
    errors,
    handleContinue,
    handleRedirect,
    loading,
    setValues,
    values,
  } = params;

  const [customerContact, setCustomerContact] = useState([]);
  const [allocatedToData, setAllocatedToData] = useState([]);
  const { data: productFamilyList } = FetchData("productfamily");

  useEffect(() => {
    if (customer?.customerContact) {
      setCustomerContact(
        customer.customerContact.map((data) => ({
          label: data?.name,
          value: data?.name,
        }))
      );
    } else {
      setCustomerContact([]);
    }
  }, [customer?.customerContact]);

  useEffect(() => {
    if (allocatedToDataProp) {
      setAllocatedToData(allocatedToDataProp);
      return;
    }

    if (distributor?.defaultCompanyDistributor === true) {
      setAllocatedToData(
        assignedEngineerList?.filter(
          (item) => item?.isActive === true || item?.identityId === values?.salesEngineerId
        )
      );
      return;
    }

    setAllocatedToData(
      assignedEngineerList?.filter(
        (item) =>
          item?.userCompanyId === values?.distributorId &&
          (item?.isActive === true || item?.identityId === values?.salesEngineerId)
      )
    );
  }, [allocatedToDataProp, assignedEngineerList, distributor, values?.distributorId, values?.salesEngineerId]);

  return (
    <>
      <div className="row" id="pills-general">
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2 quote-form-column">
          <CustomerContactSection
            {...params}
            allocatedToData={allocatedToData}
            country={country}
            customer={customer}
            customerContact={customerContact}
            distributor={distributor}
            errors={errors}
            setValues={setValues}
            values={values}
          />
        </div>

        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2 quote-form-column">
          <ProjectCommercialTermsSection
            {...params}
            distributor={distributor}
            errors={errors}
            values={values}
          />
        </div>

        {enquirySelection?.inquiryProducts?.length > 0 && (
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="attachment-heading mb-3">
              <h2>Enquiry attachments</h2>
            </div>
            <table className="table table-striped table-borderless m-0">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>File Type</th>
                  <th>File</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {enquirySelection.inquiryProducts.map((enqItem, index) => (
                  <tr key={enqItem?.id || index}>
                    <td>{productFamilyList?.find((item) => item?.id === enqItem?.productFamilyId)?.shortDesc}</td>
                    <td>{enqItem?.attachmentUrl?.split(".")[1]}</td>
                    <td>{enqItem?.attachmentUrl}</td>
                    <td>{enqItem?.productNotes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="row">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
          <div className="save-btns mt-3 mb-3 d-flex justify-content-end">
            <button className="btn cancel-btn" onClick={handleRedirect}>
              Cancel
            </button>
            <button className="btn save-btn" onClick={handleContinue} disabled={loading}>
              {!values?.id ? "Save" : "Update"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddJobInHand;
